import React, { FC, useEffect, useState } from 'react';

import ContentCard from '~/src/features/movix-new/ContentCard';

import { CARDS } from './data';

import * as ST from './styled';

const ConnectionInfo: FC = () => {
    const [isShowBigImg, setIsShowBigImg] = useState(false);

    useEffect(() => {
        const onResize = () => {
            if (window.innerWidth <= 1023) {
                setIsShowBigImg(true);
            } else {
                setIsShowBigImg(false);
            }
        };

        onResize();

        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);

    return (
        <ST.Wrapper>
            {CARDS.map(item => (
                <ContentCard key={item.title} item={item} isShowBigImg={isShowBigImg} />
            ))}
        </ST.Wrapper>
    );
};

export default ConnectionInfo;
